// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_9z-0";
export var orangeButton = "_9z-1";